import React from "react";
import { colors2, UI_BODY_SM, UI_BODY_SEMIBOLD_SM } from "oolib";
import { ButtonPrimary } from "oolib/dist/v2/components/Buttons";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { Card, CardHeader, Actions } from "./styled";

/**
 * Replaces a manage popup's body while the credential is stale: nothing can
 * sync until it is renewed. Authenticate shows only with canPublish.
 */
export const AuthExpiredCard = ({
  name,
  canPublish,
  connect,
  isConnecting,
}) => (
  <Card>
    <CardHeader>
      <Actions style={{ gap: 6 }}>
        <DisplayIcon icon="XCircle" size={18} color={colors2.red} />
        <UI_BODY_SEMIBOLD_SM style={{ color: colors2.red }}>
          Authentication expired
        </UI_BODY_SEMIBOLD_SM>
      </Actions>
    </CardHeader>
    <div style={{ padding: "24px 14px", textAlign: "center" }}>
      <UI_BODY_SM style={{ color: colors2.grey60 }}>
        {`${name} needs to be authenticated again before any of its datasets can sync. `}
        {"Your datasets and their schedules are kept."}
      </UI_BODY_SM>
      {canPublish && (
        <div style={{ marginTop: 16 }}>
          <ButtonPrimary
            onClick={() => connect()}
            isLoading={isConnecting}
            disabled={isConnecting}
          >
            Authenticate
          </ButtonPrimary>
        </div>
      )}
    </div>
  </Card>
);

export default AuthExpiredCard;
